import { Component, EventEmitter, Output } from '@angular/core';
import { SceneryService } from "../services/scenery.service";
import { DockModeService } from "../services/dock-mode.service";

declare var THREE: any;

@Component({
  selector: 'app-set-scenery',
  templateUrl: './set-scenery.component.html',
  styleUrls: ['./set-scenery.component.scss']
})
export class SetSceneryComponent {
  
  selectedSceneryType = '';

  loader = new THREE.TextureLoader();
  ground: any;
  grid: any;

  constructor(
    private sceneryService: SceneryService,
    public dockMode: DockModeService
  ) {
    this.sceneryService.changeSelectedToMenu.subscribe(name => {
      this.selectedSceneryType = name;
    })
  }

  @Output() step1Editer = new EventEmitter();

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  setGroundTexture(name) {
    this.sceneryService.change(name);
  }


}



// WEBPACK FOOTER //
// ./src/app/set-scenery/set-scenery.component.ts